import PropTypes from "prop-types";
import Button from "./Button";
import FontAwesome from "../../icon/FontAwesome";

const ButtonAccept = (props) => {
  const { children, ...attribute } = props;
  return (
    <Button color="green" {...attribute}>
      <FontAwesome fa="check" /> {children}
    </Button>
  );
};

ButtonAccept.propTypes = {
  children: PropTypes.any,
};

ButtonAccept.defaultProps = {};

export default ButtonAccept;
